namespace $.$$ {

	/** Лобби-ленд: писать могут все (с PoW), владелец читает инвайты в диалоги. */
	export class $bog_gram_inbox extends $giper_baza_dict.with({
		Invites: $giper_baza_list_str,
		/** Заявки в группу вида "группа|лорд|ключ". Отдельным списком от
		 * приглашений: приглашение — это готовый доступ, а заявка только
		 * просьба его выдать, и решение по ней принимает человек.
		 *
		 * Ключ едет прямо в записи: ленд группы шифрованный, право читать его
		 * заворачивается на ключ конкретного человека, и без ключа админу
		 * пришлось бы разыскивать просящего по реестрам. Подложить чужой ключ
		 * под чужой идентификатор это не даёт — идентификатор его хеш, и
		 * подмена ловится пересчётом на месте. */
		Joins: $giper_baza_list_str,
		/** Отказы по заявкам — ссылки на группы. Снятая из своего лобби заявка
		 * не оставляет просившему никакого следа, и она висела бы у него
		 * «ждём, пока примут» вечно. Поэтому решение кладём ему сюда: право
		 * писать в чужое лобби есть у всех, им и пользуемся.
		 *
		 * Отказ не бан: он снимает заявку из очереди и ничего не запрещает —
		 * по той же ссылке можно попроситься снова. */
		Denies: $giper_baza_list_str,
	}) {}

}
